import React, { useEffect, useState, useCallback } from "react";
import { Card, SPACING, PaddedContainer } from "@disco/disco_core";

import { HorizontalSeparator } from "../CoreUI";
import LeadGenProductRow from "../LeadGen/LeadGenProductRow";
import useData from "../../hooks/useData";
import useDimensions from "../../hooks/useDimensions";
import useWidget from "../../hooks/useWidget";
import EngageHeader from "./EngageHeader";
import EngageBottomSlot from "./EngageBottomSlot";
import useWidgetOffer from "../../hooks/useWidgetOffer";
import useShopTheme from "../../hooks/useShopTheme";
import DiscoCollectiveButton from "./DiscoCollectiveButton";
import useElementInView from "../../hooks/useElementInView";
import "./engage-widget-card.css";

const ExploreAllOffersButton = () => {
	const {
		backgroundColor: shopBackgroundColor,
		foregroundColor: shopForegroundColor,
		isConfigured: isShopThemeConfigured,
	} = useShopTheme();

	return (
		<DiscoCollectiveButton
			style={{
				"--bg": isShopThemeConfigured
					? shopBackgroundColor
					: "var(--disco-facebook)",
				"--color": isShopThemeConfigured
					? shopForegroundColor
					: "var(--disco-text-white)",
				"--border-color": "transparent",
				"--curve": "var(--disco-curve-tn)",
			}}
			secondary
			centerContent
			rounded={false}
		>
			Explore all offers
		</DiscoCollectiveButton>
	);
};

const EngageWidgetCard = () => {
	const [shouldRenderOffersSlot, setShouldRenderOffersSlot] = useState(true);
	const data = useData();
	const { containerRef } = data;
	const { isLargeWidget } = useDimensions();
	const { areOffersEmpty, activeOfferIdx } = useWidgetOffer();
	const { requestParentStats } = useElementInView();

	const { delayedTriggerResize } = useWidget({
		isEmpty: areOffersEmpty,
		containerRef,
		canTrackLoad: true,
		brandsRemoteKey: "brands",
		intersectionId: "engage-widget-card",
	});

	useEffect(() => {
		delayedTriggerResize(200)();
	}, [activeOfferIdx, delayedTriggerResize]);

	const triggerResize = useCallback(() => {
		delayedTriggerResize(0)();
	}, [delayedTriggerResize]);

	const COMPUTED_PADDING = isLargeWidget ? 20 : 16;

	return (
		<Card
			ref={containerRef}
			className="engage-widget-card"
			data-intersectionuid="engage-widget-card"
			vPadding={20}
			tightBottom
			noShadow
		>
			<PaddedContainer
				hPadding={COMPUTED_PADDING}
				vPadding={SPACING.SMALL}
				tightTop
			>
				<EngageHeader />
			</PaddedContainer>

			<EngageBottomSlot
				triggerResize={triggerResize}
				shouldRenderOffersSlot={shouldRenderOffersSlot}
				setShouldRenderOffersSlot={setShouldRenderOffersSlot}
				onAnimationComplete={requestParentStats}
			/>

			<HorizontalSeparator />

			<LeadGenProductRow
				vPadding={SPACING.TINY}
				parentHPadding={COMPUTED_PADDING}
				showHeading={false}
			/>

			{!shouldRenderOffersSlot && (
				<PaddedContainer
					vPadding={SPACING.REGULAR}
					hPadding={SPACING.REGULAR}
					tightTop
				>
					<ExploreAllOffersButton />
				</PaddedContainer>
			)}
		</Card>
	);
};

export default EngageWidgetCard;
